import React, { useCallback, useState } from 'react'
import { useMount } from 'react-use'
import dayjs from 'dayjs'
import * as apis from '@/apis'
import { Avatar, Table, Popconfirm, message,Divider,Modal,Form,DatePicker, Button } from 'antd'

export default function FinancesSummary(props) {
  const [loading, setLoading] = useState(false)
  const [total, setTotal] = useState(0)
  const [list, setList] = useState([])
  const [lastBrokerageAt, setLastBrokerageAt] = useState();
  const [binding, setBinding] = useState();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const fetch = useCallback(() => {
    setLoading(true)
    const params = {}
    console.log('props',props)
    if (props.retail) {
      params.retail = props.retail.user._id
      params.limit = 100
    }

    apis.getRetailBindedList(props.retail.user._id).then(result => {
      setLoading(false)
      setTotal(result.total)
      setList(result.data)
    })
  }, [])
  const showBrokerageDialog = useCallback(item => event => {
    event.preventDefault()
    setIsModalVisible(true)
    setBinding(item)
  })
  const columns = [
    {
      key: '_id',
      title: '散户',
      render: item => (
        <div style={{display: 'flex', alignItems: 'center'}}>
          <Avatar shape="square" src={item.retail.user.avatar} />
          <span style={{paddingLeft: 5}}>{item.retail.user.name}</span>
        </div>
      )
    },
    {
      title: '结算类型',
      render: item => item.type === 1 ? `每单固定金额` : `每单毛利比例分成`
    },
    {
      title: '结算方式',
      render: item => item.type === 1 ?
        `${item.per_order_commission}元/每单` :
        `${(item.per_order_commission_rate*100).toFixed(0)}%/每单`
    },
    // {
    //   title: '结算类型',
    //   render: item => item.type === 1 ?
    //     `每单固定 - ${item.per_order_commission}元` :
    //     `每单收入 - ${item.per_order_commission_rate}%`
    // },
   
    {
      title: '关联于',
      render: item => dayjs(item.createdAt).format('YYYY-MM-DD')
    },
    {
      title: '提成期限',
      render: item => item.lastBrokerageAt?dayjs(item.lastBrokerageAt).format('YYYY-MM-DD'):'无限期'
    },
    {
      title: '最近结算于',
      render: item => dayjs(item.lastSettlementAt).format('YYYY-MM-DD HH:mm')
    },
    {
      title: '操作',
      render: item => {
        const confirm = () => {
          apis.unbindRetailReferral(item.user._id, {
            retail: item.retail._id
          })
            .then(result => {
              message.success('已解绑')
              props.refreshList && props.refreshList()
              fetch()
            })
            .catch(error => {
              message.success(error.message || '请求错误')
            })
        }
        return (
          

<div style={{marginTop: 10}}>
        <Popconfirm
            title="风险操作，不可逆行！"
            onConfirm={confirm}
            okText="确定"
            cancelText="取消"
          >
            <a>解除</a>
          </Popconfirm>
          <Divider type="vertical" />
          <a onClick={showBrokerageDialog(item)}>设置提成期限</a>
        </div>
        )
      }
    }
  ].filter(item => Boolean(item.render))

  useMount(fetch)
  const formItemLayout = {
    labelCol: { span: 7},
    wrapperCol: { span: 15 },
  };
  const handleOk = () => {
    apis.updateRetailReferralBrokerDate(binding._id, {
      lastBrokerageAt: lastBrokerageAt,
      useRule: false,
    }).then(result => {
      message.success('修改成功')
      fetch()
    }).catch(err => {
      message.error(err.message || '发生错误')
    }).finally(() => {
      setIsModalVisible(false);
    })
  };
  const handForever =() => {
    apis.updateRetailReferralBrokerDate(binding._id, {
      lastBrokerageAt: null,
      useRule: false,
    }).then(result => {
      message.success('修改成功')
      fetch()
    }).catch(err => {
      message.error(err.message || '发生错误')
    }).finally(() => {
      setIsModalVisible(false);
    })
  };
  const handUseRule =() => {
    apis.updateRetailReferralBrokerDate(binding._id, {
      useRule: true,
    }).then(result => {
      message.success('修改成功')
      fetch()
    }).catch(err => {
      message.error(err.message || '发生错误')
    }).finally(() => {
      setIsModalVisible(false);
    })
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const updateLastBrokerageAt=(value)=>{
    setLastBrokerageAt(value)
  }
  return (
    <>
     <Table
      size="middle"
      className={props.className}
      columns={columns}
      rowKey="_id"
      dataSource={list}
      loading={loading}></Table>
    <Modal title="修改提成期限" width={680} visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
        <div>
        <Form
        {...formItemLayout}
        onSubmit={handleOk}
      >
        <Form.Item
              label="提成期限"
            >
            <DatePicker disabledTime
               onChange={updateLastBrokerageAt}
              placeholder="选择提成期限"
            />
            <Button style={{marginLeft:"10px"}} type="primary" size="small"  onClick={handForever}>无限期</Button>
            <Button style={{marginLeft:"10px"}} type="primary" size="small"  onClick={handUseRule}>使用延期规则</Button>
            </Form.Item>
            </Form>
        </div>
      </Modal>
    </>
   
  )
}
